<template>
  <ul :class="asContents ? 'contents' : 'flex flex-wrap gap-0.5'">
    <message-reaction
      v-for="[emoji, reactionData] in eventReactions"
      :key="emoji"
      :reaction-data="reactionData"
      :emoji="emoji"
      :incoming="incoming"
      :is-show-reaction-info="isShowReactionInfo"
      @toggle-reaction="emitReaction(emoji, reactionData.isSetByCurrentUser)"
    />
  </ul>
</template>

<script setup lang="ts">
import { MessageReaction } from '@/features/message-reaction'

import { ReactionsMap } from '@/entities/reaction'

import { EmittedReaction } from '@/shared/types/emitted-reaction'

withDefaults(defineProps<{
  eventReactions: ReactionsMap
  incoming?: boolean
  isShowReactionInfo: boolean
  asContents?: boolean
}>(), {
  incoming: false,
  asContents: false,
})

const emit = defineEmits<{
  (event: 'toggleReaction', payload: EmittedReaction): void
}>()

const emitReaction = (emoji: string, isSetByCurrentUser: boolean) => {
  emit('toggleReaction', { emoji, isSetByCurrentUser })
}
</script>
